import { useSuspenseQuery } from '@apollo/client';
import React from 'react';

import { Heading, Stack } from '@eluve/components';
import { graphql } from '@eluve/graphql.tada';
import { useTenantIdFromParams } from '@eluve/session-helpers';

import { AddTenantMlEngineer } from './components/AddTenantMlEngineer';
import { TenantMlEngineersList } from './components/TenantMlEngineersList';
import { tenantMlEngineerFragment } from './components/gql-operations';

const getTenantMlEngineersQuery = graphql(
  `
    query getTenantMlEngineers($tenantId: uuid!) {
      tenantsByPk(id: $tenantId) {
        ...TenantMlEngineer
      }
    }
  `,
  [tenantMlEngineerFragment],
);

export const AdminTenantMlEngineersPage: React.FC = () => {
  const tenantId = useTenantIdFromParams()!;

  useSuspenseQuery(getTenantMlEngineersQuery, {
    variables: {
      tenantId,
    },
  });

  return (
    <Stack gap={6}>
      <Heading size="2xl" weight="semibold">
        ML Engineers
      </Heading>

      <AddTenantMlEngineer />
      <TenantMlEngineersList />
    </Stack>
  );
};
